import { render, staticRenderFns } from "./HalloweenAuth.vue?vue&type=template&id=2c48bc0c"
import script from "./HalloweenAuth.vue?vue&type=script&lang=js"
export * from "./HalloweenAuth.vue?vue&type=script&lang=js"
import style0 from "./HalloweenAuth.vue?vue&type=style&index=0&id=2c48bc0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports